module.exports = __webpack_public_path__ + "media/images/exclamation-7c1b427586dd2a9073f25fccfe8cab05.svg";